module.exports = __webpack_public_path__ + "static/media/3.3362e525.png";